<template>
  <div id="app">
    <localization></localization>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Localization from '@/localization'
import gql from 'graphql-tag'
import { db } from './services/firebase/index'
const GET_CONCESIONARIO_QUERY = gql`
query getConcesionarioId($id: Int){
  getConcesionarioId(id: $id){
    id
    name
    email
    phoneNumber
    rfc
  }
}
`
export default {
  name: 'app',
  components: { Localization },
  computed: {
    ...mapState(['settings']),
    ...mapState('user', ['authorized']),
    nextRoute() {
      return this.$route.query.redirect || '/'
    },
    currentRoute() {
      return this.$route.path
    },
  },
  mounted() {
    this.$cognito.isAuthenticated()
      .then(result => {
        this.$apollo.query({
          query: GET_CONCESIONARIO_QUERY,
          variables: {
            id: parseInt(result.idToken.payload['custom:concesionarioId']),
          },
          context: {
            headers: { token: result.accessToken.jwtToken, app: 'PCON' },
          },
        })
          .then(({ data }) => {
            const userEmail = result.idToken.payload.email
            const jwt = result.accessToken.jwtToken
            const idToken = result.idToken.jwtToken
            db.collection('consSession').doc(userEmail).onSnapshot(document => {
              // console.log(document.data())
              if (document.data() === undefined) {
                // console.log('removed')
                this.$cognito.signout()
                this.$store.dispatch('user/LOGOUT_COGNITO')
              }
            })
            this.$store.dispatch('user/LOAD_CURRENT_COGNITO_ACCOUNT', {
              payload: { email: result.idToken.payload.email, franchisee: result.idToken.payload['custom:concesionarioId'], rfc: data.getConcesionarioId.rfc, jwt, idToken: idToken, name: data.getConcesionarioId.name },
            })
            var url = this.$route.query.redirect
            console.log(url)
            this.loading = false
            if (url) {
              this.$router.replace(url)
            } else {
              this.$router.replace('/')
            }
          })
          .catch(err => {
            console.log(err)
          })
        // this.$store.dispatch('user/LOAD_CURRENT_COGNITO_ACCOUNT', { payload: { email: result.idToken.payload.email, franchisee: result.idToken.payload['custom:concesionarioId'] } })
        // console.log(this.$store.state)
      })
      .catch(err => {
        console.log(err)
      })
    this.$store.commit('SET_PRIMARY_COLOR', { color: this.settings.primaryColor })
    this.$store.commit('SET_THEME', { theme: this.settings.theme })
  },
  watch: {
    '$store.state.settings.theme'(theme) {
      this.$store.commit('SET_THEME', { theme })
    },
    authorized(authorized) {
      if (authorized && this.currentRoute === '/') { /* '/auth/login')  */
        this.$router.replace(this.nextRoute)
      }
    },
    '$route'(to, from) {
      const query = Object.assign({}, to.query)
      this.$store.commit('SETUP_URL_SETTINGS', query)
    },
  },
}
</script>
